import { fileClosed } from 'features/content-library/contentLibrarySlice';
import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* closeContentLibraryFileSaga(action: ReturnType<typeof fileClosed>) {
  yield call(SignalingSocket.send, { event: 'closeLibraryFile', data: { id: action.payload } });
}
